import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): boolean {
    const isAuthFlow = globalThis.location.href.includes('code=') || globalThis.location.href.includes('error=');
    if (isAuthFlow) {
      return true;
    }

    const roles = this.getUserRoles();
    const requiredRoles = route.data['roles'] as string[];
    
    if (!roles || roles.length === 0) {
      this.logout();
      return false;
    }

    if (!requiredRoles || requiredRoles.length === 0) {
      return true;
    }

    const hasRequiredRole = requiredRoles.some(reqRole => 
      roles.some(userRole => userRole.toLowerCase() === reqRole.toLowerCase())
    );
    
    if (!hasRequiredRole) {
      if (sessionStorage.getItem('roleRedirecting')) {
        return false;
      }
      
      sessionStorage.setItem('roleRedirecting', 'true');
      const hasUserRole = roles.some(role => role.toLowerCase() === 'cert.user');
      const hasAdminRole = roles.some(role => 
        role.toLowerCase() === 'cert.admin' || role.toLowerCase() === 'cert.superadmin'
      );
      
      if (hasUserRole) {
        this.router.navigate(['/user-dashboard']).then(() => {
          sessionStorage.removeItem('roleRedirecting');
        });
      } else if (hasAdminRole) {
        this.router.navigate(['/dashboard']).then(() => {
          sessionStorage.removeItem('roleRedirecting');
        });
      } else {
        sessionStorage.removeItem('roleRedirecting');
        this.logout();
      }
      return false;
    }

    return true;
  }

  private getUserRoles(): string[] {
    try {
      const idToken = sessionStorage.getItem('CERT_IDTOKEN');
      if (!idToken) {
        return [];
      }

      const decodedToken = JSON.parse(idToken);
      return decodedToken.roles || [];
    } catch (error) {
       console.trace('Failed to parse CERT_IDTOKEN:', error);
      return [];
    }
  }

  private logout(): void {
    if (sessionStorage.getItem('loggingOut')) {
      return;
    }
    
    sessionStorage.setItem('loggingOut', 'true');
    
    const codeVerifier = sessionStorage.getItem('code_verifier');
    sessionStorage.clear();
    if (codeVerifier) {
      sessionStorage.setItem('code_verifier', codeVerifier);
    }
    sessionStorage.setItem('loggingOut', 'true');
    
    this.router.navigate(['/']);
  }
}
